<template>
  <nav class="flex-1 px-2 bg-white space-y-1">
    <router-link
      :to="{ name: 'AdminHome' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center text-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
    >
      <i
        class="fas fa-tachometer-alt-fast fa-fw"
        :class="{ 'mr-4 ml-1': !collapsed }"
      ></i>
      <span class="text-sm" v-if="!collapsed">Dashboard</span>
    </router-link>

    <router-link
      :to="{ name: 'AdminUsers' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
    >
      <i class="fas fa-users fa-fw" :class="{ 'mr-4 ml-1': !collapsed }"></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed">Users</span>
    </router-link>

    <router-link
      :to="{ name: 'AdminVideoManager' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
    >
      <i class="fas fa-tv fa-fw" :class="{ 'mr-4 ml-1': !collapsed }"></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed">Video Manager</span>
    </router-link>

    <router-link
      :to="{ name: 'AdminNetworks' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
    >
      <i class="fas fa-building fa-fw" :class="{ 'mr-4 ml-1': !collapsed }"></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed">Networks</span>
    </router-link>

    <router-link
      :to="{ name: 'AdminNetworkRequests' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
      v-if="userIsOwner()"
    >
      <i class="fas fa-lightbulb-exclamation-on fa-fw" :class="{ 'mr-4 ml-1': !collapsed }"></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed">Network Requests</span>
    </router-link>


    <router-link
      :to="{ name: 'AdminCreditManagement' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
      v-if="userIsOwner()"
    >
      <i
        class="fas fa-credit-card fa-fw"
        :class="{ 'mr-4 ml-1': !collapsed }"
      ></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed"
        >Credit Management</span
      >
    </router-link>

    <router-link
      :to="{ name: 'AdminYoutubeStatistics' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
      v-if="userIsOwner()"
    >
      <i
        class="fa-brands fa-youtube fa-fw"
        :class="{ 'mr-4 ml-1': !collapsed }"
      ></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed"
        >YouTube Statistics</span
      >
    </router-link>

    <router-link
      :to="{ name: 'AdminTools' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
    >
      <i class="fas fa-toolbox fa-fw" :class="{ 'mr-4 ml-1': !collapsed }"></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed">Tools</span>
    </router-link>

    <router-link
      :to="{ name: 'AdminVideoSalesPending' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
    >
      <i
        class="far fa-dollar-sign fa-fw"
        :class="{ 'mr-4 ml-1': !collapsed }"
      ></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed">Video Sales</span>
    </router-link>

    <router-link
      :to="{ name: 'AdminStreamSalesLayout' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
    >
      <i
        class="far fa-signal-stream fa-fw"
        :class="{ 'mr-4 ml-1': !collapsed }"
      ></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed">Stream Sales</span>
    </router-link>
    <router-link
      :to="{ name: 'AdminSupportTickets' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md overflow-hidden whitespace-nowrap"
      :class="{ 'justify-center': collapsed }"
      active-class="bg-gray-100 text-gray-900"
    >
      <i class="fas fa-headset fa-fw" :class="{ 'mr-4 ml-1': !collapsed }"></i>
      <span class="pb-1 md:pb-0 text-sm" v-if="!collapsed">Support Center</span>
    </router-link>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MediaNavigationPartial",
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    userIsOwner() {
      if(this.userInfo.roles == null) return false
      return this.userInfo.roles.some(role => role.id === 0)
    }
  }
};
</script>
